(function () {
    'use strict';
    angular.module('wamasysApp').config(['$stateProvider', function ($stateProvider) {
        var pages = [
            {name:'water-quality', url:'/water-quality?checkId', section:'planning'},
            {name:'water-quality-records', url:'/water-quality/records', section:'records'},
            {name:'water-quality-schedules', url:'/water-quality/schedules', section:'schedules'},
            {name:'water-quality-locations', url:'/water-quality/locations', section:'locations'},
            {name:'water-quality-parameters', url:'/water-quality/parameters', section:'parameters'},
            {name:'water-quality-thresholds', url:'/water-quality/thresholds', section:'thresholds'},
            {name:'water-quality-alerts', url:'/water-quality/alerts', section:'alerts'},
            {name:'water-quality-check', url:'/water-quality/check/:checkId', section:'detail'}
        ];
        pages.forEach(function (page) {
            $stateProvider.state(page.name, {
                parent:'entity', url:page.url,
                data:{authenticate:true, authorities:['ROLE_ADMIN','ROLE_SUPER_ADMIN','ROLE_WATER_QUALITY_READ','ROLE_WATER_QUALITY_EDIT'], pageTitle:'Qualité de l’eau',waterQualitySection:page.section},
                resolve:{translatePartialLoader:['$translate','$translatePartialLoader',function ($translate,$translatePartialLoader) { $translatePartialLoader.addPart('global'); return $translate.refresh(); }]},
                views:{'content@':{templateUrl:'app/business/water-quality/water-quality.html',controller:'WaterQualityController',controllerAs:'vm'}}
            });
        });
    }]);
})();
